import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

interface IProps {
  handleDiscardClick: () => void;
  onSubmit: any;
}
export const DiscardModal = ({ handleDiscardClick, onSubmit }: IProps) => {
  return (
    <Box
      sx={{
        pt: 0.5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ px: 0 }}>
        <Box sx={{ width: "100%", pb: 1 }}>
          <Typography variant="body1">
          If you change the supplier, your current changes will not be saved. Are you sure you want to continue?
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            pt: 2,
            pb: 3,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            color="error"
            sx={{
              color: "secondary.main",
              ":hover": { bgcolor: "secondary.main", color: "white" },
            }}
            onClick={handleDiscardClick}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: "#0055A8", ":hover": { bgcolor: "primary.main" } }}
            onClick={onSubmit}
          >
            Countinue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
